module.exports = __webpack_public_path__ + "img/internet.cb89070c.jpeg";